module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_rili_blue.0fc36.png";